module.exports = __webpack_public_path__ + "img/grab-handle.fba5cf6a.svg";